import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const Navigation = ({ classNames , route , href , index , isLoggedIn , isDisabled =false  })=>/*#__PURE__*/ React.createElement("a", {
        href: href,
        className: classnames(classNames, isDisabled ? 'checkout-nav-step--disabled' : ''),
        key: route.label.toLowerCase()
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark",
        className: "checkout-nav-step__icon"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__number"
    }, index + 1), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__name"
    }, route.loggedInLabel && isLoggedIn ? route.loggedInLabel : route.label))
;

export { Navigation };
//# sourceMappingURL=Navigation.js.map
